import type { Viewer } from '@cesiumgs/cesium-analytics'
import {
  CallbackProperty, Cartesian3, Color,
  ConstantPositionProperty, Entity,
  ScreenSpaceEventType, defined,
} from '@cesiumgs/cesium-analytics'
import DrawAction from './DrawAction'
import { type DrawOptions } from './DrawOptions'

/**
 * Cesium Tools for Draw Circle
 * @class DrawCircleAction
 * @extends {DrawAction}
 * @example
 * ```typescript
 * let draw=new Draw(view);
 * draw.create(DrawType.Circle,null);
 * draw.on(DrawEventType.CursorUpdate,evt=>{
 * });
 * ```
 */
export default class DrawCircleAction extends DrawAction {
  //  origin:Cesium.Cartesian3;
  // edgePoint:Cesium.Cartesian3;
  /**
   * @internal
   */
  circleEntity: Entity | undefined
  /**
   * @internal
   */
  originProperty: ConstantPositionProperty = new ConstantPositionProperty()
  /**
   * @internal
   */
  lineProperty: ConstantPositionProperty | undefined
  /**
   * @internal
   */
  vertexCompleteHandler(movement: any): void {
    // this.viewer.trackedEntity = undefined;
    //   this.renderResult = this.drawResults?.postions;
    this.removeListener()
    this.complete()
    this.state = 'end'
  }

  /**
   * @internal
   */
  cursorUpdateHandler(movement: any) {
    if (this.state === 'start') {
      const ray = this.viewer.camera.getPickRay(movement.endPosition)
      if (ray) {
        const position = this.viewer.scene.globe.pick(ray, this.viewer.scene)
        if (defined(position) && position) {
          if (this.drawResults.postions.length === 2) {
            this.drawResults.postions.splice(1, 1, position)
          }
          else {
            this.drawResults.postions.push(position)
          }
          this.updateEvt.raiseEvent(this.drawResults as any)
        }
      }
    }
  }

  /**
   * @internal
   */
  vertexAddHandler(movement: any): void {
    if (this.state === 'start')
      return
    if (this.state === 'end') {
      this.state = 'start'
    }
    const ray = this.viewer.camera.getPickRay(movement.position)
    if (ray) {
      const position = this.viewer.scene.globe.pick(ray, this.viewer.scene)
      if (position) {
        this.originProperty.setValue(position)
        this.drawResults?.postions.splice(0, 1, position)
        this.addEvt.raiseEvent(this.drawResults as any)
      }
    }
  }

  /**
   * @internal
   */
  registerViewerEvent(): void {
    this.vertexAddHandlerInstance?.setInputAction(
      this.vertexAddHandler.bind(this),
      ScreenSpaceEventType.LEFT_CLICK,
    )
    this.cursorUpdateHandlerInstance?.setInputAction(
      this.cursorUpdateHandler.bind(this),
      ScreenSpaceEventType.MOUSE_MOVE,
    )
    this.vertexCompleteHandlerInstance?.setInputAction(
      this.vertexCompleteHandler.bind(this),
      ScreenSpaceEventType.RIGHT_CLICK,
    )
  }

  /**
   * @internal
   */
  removeListener(): void {
    this.vertexAddHandlerInstance?.removeInputAction(
      ScreenSpaceEventType.LEFT_CLICK,
    )
    this.cursorUpdateHandlerInstance?.removeInputAction(
      ScreenSpaceEventType.MOUSE_MOVE,
    )
    this.vertexCompleteHandlerInstance?.removeInputAction(
      ScreenSpaceEventType.RIGHT_CLICK,
    )
  }

  /**
   * Creates an instance of DrawCircleAction.
   * @param {Cesium.Viewer} viewer init mapView
   * @param {DrawOptions} [options]
   * @memberof DrawCircleAction
   */
  constructor(viewer: Viewer, options?: DrawOptions) {
    super(viewer, options)

    this.type = 'circle'

    if (this.drawoptions?.useDefaultEntity) {
      this.originProperty = new ConstantPositionProperty()
      this.lineProperty = new ConstantPositionProperty()
      const entity
        = this.drawoptions.defaultCircleEntity
        || new Entity({
          position: this.originProperty,
          polyline: {
            positions: new CallbackProperty(() => {
              return this.drawResults.postions
            }, false),
            width: 1,
            material: Color.WHITE,
          },
          ellipse: {
            semiMajorAxis: new CallbackProperty(() => {
              if (this.drawResults.postions.length === 2) {
                return Cartesian3.distance(
                  this.drawResults.postions[0],
                  this.drawResults.postions[1],
                )
                //  let r = Math.sqrt(Math.pow(this.drawResults.postions[0].x - this.drawResults.postions[1].x, 2)) + Math.pow(this.drawResults.postions[0].y - this.drawResults.postions[1].y, 2);
                //   return r ? r : r + 1;
              }
              return 1
            }, false),
            semiMinorAxis: new CallbackProperty(() => {
              if (this.drawResults.postions.length === 2) {
                return Cartesian3.distance(
                  this.drawResults.postions[0],
                  this.drawResults.postions[1],
                )
                const r
                  = Math.sqrt(
                    (this.drawResults.postions[0].x
                      - this.drawResults.postions[1].x) ** 2,
                  )
                  + (this.drawResults.postions[0].y
                    - this.drawResults.postions[1].y) ** 2
                return r || r + 1
              }
              return 1
            }, false),
            material: Color.fromCssColorString('#FFD040'),
            outline: true,

          },
        })
      this.circleEntity = this.dataSource.entities.add(entity)
    }
    // this.renderResult = new Array<Cesium.Cartesian3>();

    /* if (this.drawoptions?.useDefaultEntity) {
          let addEntity =
            this.drawoptions?.defaultLineEntity ||
            new Cesium.Entity({
              polygon: {
                hierarchy: new Cesium.CallbackProperty(() => {
                  let arrPoint = new Cesium.PolygonHierarchy(this.renderResult);
                  return arrPoint;
                }, false),

                material: Cesium.Color.fromCssColorString('#FF6E40'),
              },
            });

          this.addEntity = this.dataSource.entities.add(addEntity);
        } */
  }
}
